<template>
    <div>
        <v-row class="mb-4 w-100 d-flex align-center justify-space-">
            <v-col cols="12" lg="4" class="flex-grow-0 flex-shrink-1">
            </v-col>
            <v-col cols="12" lg="4" class="flex-grow-1 flex-shrink-0">
                <h2 class="titulo text-center">
                    Grupos Disponíveis ({{ pedido.plano.prazo_comercializacao }} Meses)
                </h2>
            </v-col>
            <v-col v-if="!pedido.id_reserva" cols="12" lg="4" class="text-center text-lg-end mb-4 mb-lg-1 pr-6 informativa text-align-center">
                <span>
                    Caso deseje reservar, vá ao menu “Reservas”*
                </span>
            </v-col>
        </v-row>
        <v-expansion-panels class="mx-1" v-model="grupo_expandido" accordion wrapper multiple v-if="!pedido.plano.apenas_reserva">
            <v-expansion-panel v-for="(grupo, index) in grupos" :key="index" class="card round-corner mb-8">
                <v-expansion-panel-header hide-actions>
                    <v-layout wrap class="grupo-header" pb-2>
                        <v-flex md9 class="d-flex justify-center pl-0 ">
                            <v-row class="d-flex">
                                <v-col cols="12" sm="4" class="pd-0 mt-4 ml-n1 xs">
                                    <span class="codigo_grupo">
                                        {{ parseInt(grupo.CD_Grupo) }}
                                    </span>
                                </v-col>
                            </v-row>
                            <v-row class="d-flex justify-center row-infos-principais mt-4 flex-wrap">
                                <div class="cotas-disponiveis" @click.stop>
                                    {{ (isLoading(grupo.Caracteristicas.qt_cotas, grupo) || 'Não há') }}
                                    <span v-if="isLoading(grupo.Caracteristicas.qt_cotas, grupo) !== 'Carregando...'">COTAS DISPONÍVEIS</span>
                                </div>
                                <v-col cols="5">
                                    <label>Última assembleia apurada</label>
                                    <p class="mt-1">
                                        {{ getUltimaAssembleiaApurada(grupo, "Mes_Apuracao_1") }}
                                    </p>
                                </v-col>
                                <v-col cols="5">
                                    <label>Contemplações totais</label>
                                    <p class="mt-1">
                                        {{ isLoading(grupo.Caracteristicas.QT_Contemplada_1, grupo) }}
                                    </p>
                                </v-col>
                                <v-col cols="5">
                                    <label>Prazo restante</label>
                                    <p class="mt-1">
                                        {{ isLoading(grupo.PZ_Restante, grupo) }}
                                    </p>
                                </v-col>
                                <v-col cols="5">
                                    <label>Valor da parcela</label>
                                    <p class="mt-1">
                                        {{ getValorDaParcela(grupo) }}
                                    </p>
                                </v-col>
                            </v-row>
                        </v-flex>
                        <v-flex xs12 md3>
                            <v-layout wrap class="row-padding">
                                <v-flex class="col-12 mb-5 mt-5 mt-md-0" @click="chamarRealizaVendaFluxoEscolherGrupo(grupo)" v-if="!grupo.Caracteristicas.Erro && !pedido.plano.apenas_reserva">
                                    <v-btn id="ButtonVenda" color="primary" block class="escolher_grupo">
                                        {{ getTextButtonRealizarVenda(grupo) }}
                                    </v-btn>
                                </v-flex>
                                <v-flex class="col-12 mb-5 mt-5 mt-md-0" @click="getGrupo(grupo)" v-else-if="grupo.Caracteristicas.Erro">
                                    <v-btn id="ButtonTentarNovamente" color="secondary" block>
                                        Tentar Novamente
                                    </v-btn>
                                </v-flex>
                                <v-flex class="col-12 mb-4">
                                    <AditamentoButton :id-plano-venda="pedido.plano.id_plano_venda" :tipo-estilo-botao="false"> </AditamentoButton>
                                </v-flex>
                            </v-layout>
                            <v-layout v-if="permite_flavor_todos_produtos" wrap class="row-padding ml-1 mt-3" style="font-weight: bold"> Administrado por {{ administradora }}. </v-layout>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-header>
                <v-expansion-panel-content v-if="!pedido.plano.apenas_reserva" class="flex">
                    <v-layout class="grupo-content" pt-4 wrap>
                        <v-flex class="xs12 sm6 md3">
                            <label>Taxa de administração total</label>
                            <p>{{ isLoading(grupo.PE_TA_Total.toLocaleString(), grupo) }}%</p>
                        </v-flex>
                        <v-flex class="xs12 sm6 md3">
                            <label>Seguro mensal</label>
                            <p>
                                {{ getSeguroMensal(grupo) }}
                            </p>
                        </v-flex>
                        <v-flex class="sm6 md3">
                            <label>Prazo original do grupo</label>
                            <p>{{ isLoading(grupo.Caracteristicas.PZ_Comercializacao, grupo) }}</p>
                        </v-flex>
                        <v-flex class="sm6 md3">
                            <label>Quantidade de parcelas furo</label>
                            <p>{{ pedido.plano.situacao_grupo !== SituacaoGrupo.Formacao ? calcularParcelasFuro(grupo) : "-" }}</p>
                        </v-flex>
                        <v-flex class="sm6 md3">
                            <label>Quantidade de participantes</label>
                            <p>
                                {{ isLoading(grupo.Caracteristicas.QT_Participantes, grupo) }}
                            </p>
                        </v-flex>
                        <v-flex class="sm6 md3">
                            <label>Data da próxima assembleia</label>
                            <p>{{ getDateLabel(grupo.Caracteristicas.DT_Assembleia) }}</p>
                        </v-flex>
                        <v-flex class="sm6 md3">
                            <label>Vencimento da próxima assembleia</label>
                            <p>{{ getDateLabel(grupo.Caracteristicas.DT_Vencimento) }}</p>
                        </v-flex>
                        <v-flex class="sm6 md3">
                            <label>Negociação do pagamento do furo</label>
                            <p class="opcao-furo">
                                {{ pedido.plano.situacao_grupo !== SituacaoGrupo.Formacao ? getOpcaoFuroDisplayValue(grupo) : '-' }}
                            </p>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap card-assembleias>
                        <v-flex class="xs12 sm12 md6">
                            <label>Penúltima assembleia apurada</label>
                            <p>
                                {{ getUltimaAssembleiaApurada(grupo, "Mes_Apuracao_2") }}
                            </p>
                        </v-flex>
                        <v-flex class="xs12 sm6 md6">
                            <label>Contemplações totais</label>
                            <p>
                                {{ isLoading(grupo.Caracteristicas.QT_Contemplada_2, grupo) }}
                            </p>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap card-assembleias mt-3>
                        <v-flex class="xs12 sm12 md6 pb-sm1">
                            <label>Antepenúltima assembleia apurada</label>
                            <p>
                                {{ getUltimaAssembleiaApurada(grupo, "Mes_Apuracao_3") }}
                            </p>
                        </v-flex>
                        <v-flex class="xs12 sm6 md6">
                            <label>Contemplações totais</label>
                            <p>
                                {{ isLoading(grupo.Caracteristicas.QT_Contemplada_3, grupo) }}
                            </p>
                        </v-flex>
                    </v-layout>
                </v-expansion-panel-content>
                <v-layout v-if="!pedido.plano.apenas_reserva" wrap column text-center @click="toggleGrupo(index)" toggle-detalhes>
                    <v-flex>
                        <p style="margin-bottom: 0;" class="font-weight-medium mt-2">{{ grupo_expandido.findIndex(value => value === index) > -1 ? "menos" : "mais" }} detalhes</p>
                    </v-flex>
                    <v-flex>
                        <v-icon color="primary" :class="{ rotate90: index !== grupo_expandido, rotate270: index === grupo_expandido }">
                            chevron_right
                        </v-icon>
                    </v-flex>
                </v-layout>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-btn id="ButtonVoltar" text color="secondary" @click="voltar">Voltar</v-btn>
        <DialogListagemCotas :quantidade-cotas="1" v-model="dialog_cotas_disponiveis" :dados="grupo" @utilizarReserva="utilizarReserva" />
        <ListDialog v-model="dialog_filial" title="ESCOLHA A FILIAL" :items="filiais_visiveis" :search-keys="['CD_Filial_Venda', 'NM_Filial_Venda']" @select="selecionarFilial" :item-text="filialTextDialog" />
    </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { merge, omitBy } from 'lodash'
  import { money, toDateBR } from '@/plugins/formatters'
  import { alert, notification, getNomeEmpresaPorIdEmpresa, getComissionadoNormalized } from '@/plugins/helpers'
  import { OpcoesFuroDesc, OrigemReserva, TipoNegociacao } from '@/plugins/constants'
  import DialogListagemCotas from '@/dialogs/DialogListagemCotas'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  import AditamentoButton from '../../../components/AditamentoButton.vue'
  import { SituacaoGrupo } from '../../../plugins/constants'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import loadFiliais from '../../../mixins/loadFiliais'

  const grupo_pattern = () => ({
    ID_Grupo: 0,
    CD_Grupo: '0',
    PE_FC: 0,
    PE_TA_Total: 0,
    PE_SG_F: 0,
    PZ_Comercializacao: 0,
    Caracteristicas: {
      Carregado: false,
      Erro: false,
      DT_Vencimento: '0000-01-01',
      QT_Sorteio: 0,
      QT_Participantes: 0,
      DT_Assembleia: '0000-01-01',
      PC_MenorLance_1: 0.0,
      PC_MaiorLance_1: 0.0,
      PC_MenorLance_2: 0.0,
      PC_MaiorLance_2: 0.0,
      PC_MenorLance_3: 0.0,
      PC_MaiorLance_3: 0.0
    },
    GrupoReserva: {
      Carregado: false,
      permite_reservar: false,
      Erro: false
    }
  })

  export default {
    name: 'SelecionarGrupo',
    components: { DialogListagemCotas, AditamentoButton },
    mixins: [loadFiliais],
    props: { value: Object },
    data: () => ({
      grupo_expandido: [],
      pedido: {
        identificador_representante_tribanco: null,
        fluxo_venda_atual: 'iniciar_venda',
        multiplicador_cota_habilitado_na_venda: false,
        flavor_atual: null,
        saldo_para_aumentar: '0'
      },
      grupos: [],
      grupo: {},
      dialog_cotas_disponiveis: false,
      filial: [],
      filiais_visiveis: [],
      dialog_filial: false,
      grupo_escolhido: [],
      administradora: '',
      permite_flavor_todos_produtos: false
    }),
    computed: {
      ...mapState(['id_ponto_venda', 'id_comissionado_venda', 'id_empresa', 'id_unidade_negocio', 'id_usuario', 'filiais', 'jornada_venda', 'hierarquia_comercial', 'vendas_backoffice']),
      OpcoesFuroDesc: () => OpcoesFuroDesc,
      SituacaoGrupo: () => SituacaoGrupo
    },
    async mounted () {
      await this.loadFiliais()
      this.pedido.flavor_atual = this.$session.get('flavor') || null
      this.permite_flavor_todos_produtos = this.$session.get('permite_venda_todos_produtos')
    },
    created () {
      this.pedido = merge({}, this.pedido, this.value)
      const grupos = [...this.pedido.grupos]
      delete this.pedido.grupos
      grupos.forEach(grupo => {
        let prazo = this.pedido.plano.tipo_negociacao === TipoNegociacao.Diluido ? 'PZ_Restante' : 'PZ_Comercializacao'
        if ((grupo[prazo] === parseInt(this.pedido.plano.prazo_comercializacao) || grupo[prazo] === parseInt(this.pedido.plano.pz_restante)) && grupo.VL_Fisica === parseFloat(this.pedido.plano.valor_parcela)) {
          let grupo_item = { ...grupo_pattern(), ...grupo }
          this.grupos.push(grupo_item)
          this.getGrupo(grupo_item)
          this.getGrupoReserva(grupo_item)
        }
      })
      if (this.pedido.plano.apenas_reserva && !this.pedido.id_reserva) {
        notification(AlertTypes.WARN, 'Caro parceiro, o grupo em questão permite apenas reservas. Em caso de dúvidas entre em contato com a Área de Suporte!')
      }
    },
    methods: {
      filialTextDialog (item) {
        return `${item.CD_Filial_Venda} - ${item.NM_Filial_Venda}`
      },
      getGrupo (grupo_item) {
        this.administradora = getNomeEmpresaPorIdEmpresa(grupo_item.ID_Empresa)

        grupo_item.Caracteristicas.Carregado = false
        grupo_item.Caracteristicas.Erro = false
        this.getCaracteristicas(grupo_item)
          .then(({ data }) => {
            grupo_item.Caracteristicas = omitBy(data.caracteristicas_grupo.CaracteristicaGrupo.CaracteristicaGrupo[0], value => {
              return value === 0 || value === '' || value === undefined || value === null
            })
            grupo_item.Caracteristicas.qt_cotas = data.qt_cotas
            grupo_item.Caracteristicas.Carregado = true
          })
          .catch(() => {
            grupo_item.Caracteristicas.Erro = true
            notification(AlertTypes.ERROR, `Não foi possível carregar as características do grupo ${grupo_item.CD_Grupo}`)
          })
      },
      getGrupoReserva (grupo_item) {
        grupo_item.GrupoReserva.Carregado = false
        grupo_item.GrupoReserva.Erro = false
        this.getGruposReserva(grupo_item)
          .then(res => {
            grupo_item.GrupoReserva.permite_reservar = res.data.permite_reservar
            grupo_item.GrupoReserva.Carregado = true
          })
          .catch(() => {
            grupo_item.GrupoReserva.Erro = true
            alert(`Não foi possível carregar as informações da reserva do grupo ${grupo_item.CD_Grupo}`)
          })
      },
      getSeguroMensal (grupo) {
        return this.isLoading(grupo.PE_SG_F.toLocaleString('pt-BR', { maximumFractionDigits: 20 }), grupo) + '%'
      },
      getTextButtonReserva (grupo) {
        return grupo.Caracteristicas.Carregado ? (grupo.GrupoReserva.permite_reservar ? 'Reservar' : 'Reserva Indisponível') : 'Carregando...'
      },
      getTextButtonRealizarVenda (grupo) {
        let texto = 'Carregando...'

        if (grupo.Caracteristicas.Carregado) {
          return parseInt(this.pedido.id_reserva) > 0 ? 'Avançar' : 'Escolher Grupo'
        } else {
          return texto
        }
      },
      getGruposReserva (grupo) {
        const idPontoVenda = this.$session.get('id_ponto_venda')
        const idUnidadeNegocio = this.$session.get('id_unidade_negocio')
        return this.$http.get(`/reservas/validareserva/${grupo.ID_Grupo}`, {
        params: {
          id_ponto_venda: idPontoVenda,
          id_unidade_negocio: idUnidadeNegocio
        }, options: { silent: true } })
      },
      getValorDaParcela (grupo) {
        if (grupo.Caracteristicas.Carregado) {
          return money(this.pedido.plano.valor_parcela || 0)
        }
        return 'Carregando...'
      },
      isLoading (variable, grupo) {
        return grupo.Caracteristicas.Carregado ? variable || '-' : 'Carregando...'
      },
      calcularParcelasFuro (grupo) {
        if (grupo.Caracteristicas?.Erro) {
          return '-'
        }
        if (grupo.Caracteristicas?.Carregado) {
          const { PZ_Comercializacao: pzComercializacao, PZ_Decorrido: pzDecorrido } = grupo.Caracteristicas
          const prazoComercializacao = this.pedido.plano.prazo_comercializacao

          if (pzComercializacao !== undefined && pzDecorrido !== undefined && prazoComercializacao !== undefined) {
            const prazoRestante = pzComercializacao - pzDecorrido
            if (prazoRestante >= prazoComercializacao) {
              return 'Não há'
            }
            const parcelasFuro = prazoRestante - prazoComercializacao
            return Math.abs(parcelasFuro)
          }
          return 'Não há'
        }
        return 'Carregando...'
      },
      getDisplayValue (variable, grupo, defaultValue = 'Não há.') {
        if (grupo.Caracteristicas?.Erro) {
          return '-'
        }
        return grupo.Caracteristicas.Carregado ? variable || defaultValue : 'Carregando...'
      },
      getOpcaoFuroDisplayValue (grupo) {
        const situacaoGrupo = this.pedido.plano.situacao_grupo
        const parcelasFuro = this.calcularParcelasFuro(grupo)
        if (parcelasFuro === '-' && situacaoGrupo === SituacaoGrupo.Formacao) {
          return '-'
        }
        if (situacaoGrupo !== SituacaoGrupo.Formacao && parcelasFuro === 'Não há') {
          if (grupo.opcao_furo === 'diluicao' || grupo.opcao_furo === 'furo_encerramento') {
            return '-'
          }
        }
        return this.getDisplayValue(OpcoesFuroDesc[grupo.opcao_furo], grupo)
      },
      getCaracteristicas (grupo) {
        return this.$http.get('/grupos/caracteristicas_com_qt_cotas', {
          params: {
            ID_Grupo: grupo.ID_Grupo
          },
          options: { silent: true }
        })
      },
      toggleGrupo (index) {
        const value = this.grupo_expandido.findIndex(value => value === index)
        if (value > -1) {
          delete this.grupo_expandido.shift(value)
        } else {
          this.grupo_expandido.push(index)
        }
      },
      getDateLabel (date) {
        return date !== '0000-01-01' ? toDateBR(date) : 'Carregando...'
      },
      async utilizarReserva (grupo) {
        await this.$nextTick()
        await this.realizarVenda(grupo, true)
        this.pedido = { ...this.pedido, completa: true }
        this.$emit('reload', this.pedido)
      },
      getUltimaAssembleiaApurada (grupo, nameMes) {
        if (!grupo.Caracteristicas.Carregado) {
          return 'Carregando...'
        } else if (!grupo.Caracteristicas[nameMes]) {
          return '-'
        }
        return grupo.Caracteristicas[nameMes]
      },
      async selecionarFilial (filial) {
        this.filial = filial
        this.$session.set('filial', filial)
        this.dialog_filial = false

        if (this.grupo_escolhido['ID_Grupo'] > 0) {
          this.realizarVenda(this.grupo_escolhido)
          this.grupo_escolhido = []
        }
      },
      reservar (grupo) {
        if (!grupo.Caracteristicas.Carregado || !grupo.GrupoReserva.permite_reservar) {
          return
        }
        if (typeof this.pedido.grupos_originais === 'object') {
          this.pedido.grupos_originais = Object.values(this.pedido.grupos_originais)
        }
        this.pedido.grupos_originais = this.pedido.grupos_originais.filter(grupo_original => grupo_original.ID_Grupo === grupo.ID_Grupo)
        this.grupo = {
          ...grupo,
          ...{
            ID_Tipo_Venda: grupo['ID_Tipo_Venda_Grupo'],
            ID_Ponto_Venda: this.id_ponto_venda,
            ID_Comissionado: this.id_comissionado_venda,
            ID_Empresa: this.$session.get('permite_venda_todos_produtos') ? grupo['ID_Empresa'] : this.id_empresa,
            ID_Unidade_Negocio: this.id_unidade_negocio,
            ID_Filial_Venda: this.filial.ID_Filial_Venda,
            NM_Bem: this.pedido.bem.nome_bem,
            valor_bem: this.pedido.bem.valor_bem,
            taxa_adm: grupo.PE_TA_Total,
            vl_fisica: grupo.VL_Fisica,
            nome_plano: this.pedido.plano.nome_plano,
            PZ_Comercializacao: grupo.PZ_Comercializacao,
            pz_restante: grupo.PZ_Restante,
            completa: true,
            CD_Grupo: grupo.CD_Grupo,
            pe_seguro: grupo.PE_SG_F,
            dt_vencimento: grupo.Caracteristicas.DT_Vencimento,
            dt_assembleia: grupo.Caracteristicas.DT_Assembleia,
            cd_plano_venda: this.pedido.plano.cd_plano_venda,
            tipo_negociacao: this.pedido.plano.tipo_negociacao,
            situacao_grupo: this.pedido.plano.situacao_grupo,
            cd_produto: this.pedido.produto.cd_produto,
            nome_produto: this.pedido.produto.nome_produto,
            nome_filial: this.filial.NM_Filial_Venda || this.filial.NM_Filial,
            cd_filial: this.filial.CD_Filial_Venda,
            id_unidade_negocio: this.id_unidade_negocio,
            qt_participantes: grupo.Caracteristicas.QT_Participantes,
            qtd_parcela_furo: this.calcularParcelasFuro(grupo) === 'Não há' || this.calcularParcelasFuro(grupo) === '-' ? 0 : this.calcularParcelasFuro(grupo),
            grupos_originais: this.pedido.grupos_originais,
            origem: OrigemReserva.FluxoVenda
          }
        }

        if (this.pedido.plano.situacao_grupo === SituacaoGrupo.Formacao) {
          this.grupo.opcao_furo = null
        } else {
          this.grupo.opcao_furo = grupo.opcao_furo
        }

        this.sendAnalytics(grupo.CD_Grupo)
        this.dialog_cotas_disponiveis = true
      },
      async chamarRealizaVendaFluxoEscolherGrupo (grupo) {
        if (this.filiais_visiveis.length === 0) {
          await this.loadFiliais()
        }

        if (this.filiais_visiveis.length > 1) {
          this.dialog_filial = true
          this.grupo_escolhido = grupo
        }

        if (this.filiais_visiveis.length === 1) {
          this.filial = this.filiais_visiveis[0]
          this.$session.set('filial', this.filial)
          await this.realizarVenda(grupo)
        }
      },
      async realizarVenda (grupo, isReserva = false) {
        try {
          if (grupo.Caracteristicas.Carregado) {
            this.pedido.grupo = {
              id_grupo: grupo.ID_Grupo,
              cd_grupo: grupo.CD_Grupo,
              taxa_adm: grupo.PE_TA_Total,
              pe_lance_fixo: grupo.Caracteristicas.PE_Lance_Fixo,
              pe_seguro: grupo.PE_SG_F,
              dt_vencimento: grupo.Caracteristicas.DT_Vencimento,
              dt_assembleia: grupo.Caracteristicas.DT_Assembleia,
              qt_participantes: grupo.Caracteristicas.QT_Participantes,
              qtd_parcela_furo: this.calcularParcelasFuro(grupo) === 'Não há' || this.calcularParcelasFuro(grupo) === '-' ? 0 : this.calcularParcelasFuro(grupo)
            }
            this.pedido.id_filial = this.filial.ID_Filial_Venda
            this.pedido.nome_filial = this.filial.NM_Filial_Venda
            this.pedido.cd_filial = this.filial.CD_Filial_Venda
            this.pedido.id_usuario = this.id_usuario
            const comissionadoData = getComissionadoNormalized(this.$session.get('id_comissionado_venda'), this.$session.get('comissionados'), this.$session.get('vendas_backoffice'))
            this.pedido.id_comissionado = comissionadoData.id_comissionado
            this.pedido.cd_comissionado = comissionadoData.cd_comissionado
            this.pedido.nm_comissionado = comissionadoData.nm_comissionado
            this.pedido.id_empresa = this.$session.get('permite_venda_todos_produtos') ? grupo['ID_Empresa'] : this.id_empresa
            this.pedido.id_unidade_negocio = this.id_unidade_negocio
            this.pedido.id_ponto_venda = this.$session.get('id_ponto_venda')
            this.pedido.vl_parcela_com_seguro = parseFloat(this.pedido.plano.valor_parcela).toFixed(2)
            this.pedido.id_empresa_venda_logada = this.id_empresa
            this.pedido.backoffice = this.$session.get('vendas_backoffice')
            this.pedido.origem_acesso = this.$session.get('origem_acesso')
            this.pedido.flavor_atual = this.$session.get('flavor')
            if (this.pedido.backoffice) {
              this.pedido.nm_ponto_venda = this.$session.get('nm_ponto_venda')
              this.pedido.cd_ponto_venda = this.$session.get('cd_ponto_venda')
            }

            if (isReserva) {
              this.pedido.cd_cota = grupo.CD_Cota
              this.pedido.id_reserva = grupo.ID_Reserva
            }

            if (typeof this.pedido.grupos_originais === 'object') {
              this.pedido.grupos_originais = Object.values(this.pedido.grupos_originais)
            }

            this.pedido.grupos_originais = this.pedido.grupos_originais.filter(grupo_original => grupo_original.ID_Grupo === grupo.ID_Grupo)
            this.pedido.plano.pz_restante = grupo.PZ_Restante
            this.pedido.nm_ponto_venda = this.$session.get('nm_ponto_venda')
            this.pedido.cd_ponto_venda = this.$session.get('cd_ponto_venda')
            this.pedido.identificador_representante_tribanco = this.$session.get('identificador_representante_tribanco')
            const ambiente = this.$session.get('ambiente')
            if (ambiente && ambiente.unidade_condicoes_venda) {
              this.pedido.unidade_condicoes_venda = ambiente.unidade_condicoes_venda
            }
            if (this.pedido.plano.situacao_grupo === SituacaoGrupo.Formacao) {
              this.pedido.plano.opcao_furo = null
            }

            const response = await this.$http.post('/vendas', this.pedido)

            this.pedido = { ...this.pedido, ...response.data }

            this.sendAnalytics()
            this.$emit('input', this.pedido)
            if (!isReserva) {
              this.$emit('nextPage')
            }
          }
        } catch (err) {
          if (err.response && err.response.data && err.response.data.Msg_Erro) {
            notification(AlertTypes.ERROR, err.response.data.Msg_Erro, 'Não foi possível selecionar o grupo')
          } else {
            notification(AlertTypes.ERROR, err, 'Não foi possível selecionar o grupo')
          }
        }
      },
      sendAnalytics (cdGrupo = null) {
        sendAnalyticsEvent(this.$gtag, cdGrupo !== null ? 'grupo_reservar' : 'grupo_escolher', {
          grupo: cdGrupo !== null ? cdGrupo : this.pedido.grupo.cd_grupo,
          source_menu: this.jornada_venda
        })
      },
      voltar () {
        this.$emit('input', this.pedido)
        this.$emit('prevPage')
      }
    }
  }
</script>
<style scoped lang="scss">
.grupo-header {
    border-bottom: 1px solid var(--v-gray-lighten1);
}

.grupo-header p,
.grupo-content p {
    padding-bottom: 10px;
}

.grupo-content {
    padding-left: 20px;
}

.v-expansion-panel-header {
    padding-bottom: 0;
}

.codigo_grupo {
    padding: 5px 10px;
    background: var(--primary);
    color: #fff;
    border-radius: 5px;
    font-size: 1.2rem;
}

.v-expansion-panel p {
    margin-bottom: 0;
    color: var(--primary);
}

.v-expansion-panel p {
    margin-bottom: 0;
    color: var(--primary);
}

.v-expansion-panel label {
    margin-bottom: 0;
    color: var(--dark);
}

.v-expansion-panel p,
.v-expansion-panel label {
    font-size: 1rem !important;
}

.v-expansion-panel-header p {
    line-height: 1.5;
}

.card-assembleias {
    background: var(--v-gray-lighten1);
    padding: 10px;
    border-radius: 10px;
    margin-left: 10px;
}

.toggle-detalhes {
    padding: 10px 0 4px;
    cursor: pointer;
    transition: all ease 500ms;

    &:hover {
        background: var(--primaryTransparent);
    }
}

// v-expansion-panel tem shadow vertical mas não tem bordas horizontais
.card {
    border-left: 1px solid var(--v-gray-lighten1);
    border-right: 1px solid var(--v-gray-lighten1);
    max-width: 95%;
}

.card::after {
    border: none;
}

.row-infos-principais p{
    position: relative;
    overflow: visible;
    font-weight: 600;
}
.cotas-disponiveis {
  position: absolute;
  display:block;
  top: -10px;
  left: -10px;
  background-color: white;
  z-index: 5;
  border: 1px solid var(--primary);
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: bold;
  color: var(--primary);
  cursor: default;
}
.informativa {
    font-weight: bold;
    font-size: 1.2rem;
    color: var(--v-gray-darken2);
}
</style>
